import React from 'react';
import { assets } from '../../styles/theme';

const Logo = ({ variant = 'v2SonoRotina', className = '', size = 'md' }) => {
  const sizes = {
    sm: 'h-8',
    md: 'h-12',
    lg: 'h-16',
    xl: 'h-24'
  };

  return (
    <img 
      src={assets.logos[variant]} 
      alt="Mari Mello - Sono e Rotina" 
      className={`${sizes[size]} w-auto ${className}`}
    />
  );
};

export default Logo;
